<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mt-2">
          <v-card-title style="color:#1f245b">Rekapitulasi 
            <v-spacer></v-spacer>
            <v-btn @click="clickedDownload()" color="primary">
              <v-icon>
                mdi-download
              </v-icon>
              Download
            </v-btn>
          </v-card-title>

          <v-dialog
            v-model="dialog4"
            max-width="600"
          >
            <v-card>
              <v-toolbar
                color="primary text-h6"
                dark
              >Rekap
              <v-spacer></v-spacer>
              <v-dialog
                ref="dialog4"
                v-model="modal3"
                :return-value.sync="datesDownload"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-col cols="6">
                  <v-text-field
                    v-model="datesDownloadText"
                    label="Pick Date"
                    prepend-icon="mdi-clock-time-four-outline"
                    class="mt-6"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    
                  ></v-text-field>
                  </v-col>
                </template>
                <v-date-picker
                  v-if="modal3"
                  v-model="datesDownload"
                  full-width
                  range
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="modal3 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog4.save(datesDownload);getRecap(datesDownload)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              </v-toolbar>
              <v-card-actions>
                <download-csv
                  class   = "btn btn-default"
                  :data   = "recapDetail"
                  :name    = "csvTitleRecap"
                  separator-excel
                  :labels  = "labelsCSVRecap">
                  <v-btn class="float-end" color="primary"><v-icon left>mdi-download</v-icon>Download</v-btn>
                </download-csv>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="dialog4 = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="data"
                  :items-per-page="5"
                  :calculate-widths="true"
                  item-key="station"
                  class="elevation-1"
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                  }"
                >
                <template v-slot:[`item.station`]="{ item }">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-title>{{item.station}}</v-list-item-title>
                      <v-list-item-subtitle>{{item.phoneNumber}} - {{item.macAddress}}</v-list-item-subtitle>
                      <v-list-item-subtitle>New ID/Feed ID: {{ item.newID }}/ {{ item.feedingID }} </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:[`item.timeReport`]="{ item }">
                  {{updateTime(item.timeReport)}}
                </template>
                <template v-slot:[`item.quota`]="{ item }">
                  {{item.quota}} MB
                </template>
                <template v-slot:[`item.id`]="{ item }">
                  <v-btn icon @click="clicked(item)" color="primary">
                    <v-icon>
                      mdi-download
                    </v-icon>
                  </v-btn>
                </template>
                </v-data-table>
                <v-dialog
                  v-model="dialog"
                  max-width="600"
                >
                  <v-card>
                    <v-toolbar
                      color="primary text-h6"
                      dark
                    >{{ station }}
                    <v-spacer></v-spacer>
                    <v-dialog
                      ref="dialog"
                      v-model="modal2"
                      :return-value.sync="time"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-col cols="6">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Pick Date"
                          prepend-icon="mdi-clock-time-four-outline"
                          class="mt-6"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          
                        ></v-text-field>
                        </v-col>
                      </template>
                      <v-date-picker
                        v-if="modal2"
                        v-model="dates"
                        full-width
                        range
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="modal2 = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(time);getData(ID)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                    </v-toolbar>
                    <v-card-actions>
                      <download-csv
                        class   = "btn btn-default"
                        :data   = "historicalDetail"
                        :name    = "csvTitle"
                        separator-excel
                        :labels  = "labelsCSV">
                        <v-btn class="float-start mb-2" color="primary" text><v-icon left>mdi-download</v-icon>Download</v-btn>
                      </download-csv>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialog = false"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import firebase from "firebase/app"
import { db }from "../firebase/db.js"
import moment from 'moment'
// import { Bar } from 'vue-chartjs/legacy'

// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

  export default {
    name: 'DataPage',
    // components: { Bar },

    data: () => ({
      headers: [
          {
            text: 'Stasiun',
            align: 'start',
            value: 'station',
          },
          { text: 'Lokasi', value: 'location' },
          { text: 'Curah Hujan (mm)', value: 'curah' },
          { text: 'Waktu', value: 'timeReport' },
          { text: 'Kuota', value: 'quota' },
          { text: 'Masa Aktif', value: 'tenggang' },
          { text: 'Download', value: 'id'}
        ],
      historical:[],
      time:[],
      devices:[],
      data:[],
      loadingData: true,
      offset:0,
    
      station:null,
      dialog:false,
      ID:null,
      chartData: {
        labels: [],
        datasets: [ { label: 'Curah',data: [],backgroundColor: '#3f51b5', } ],
      },
      chartOptions: {
        responsive: true
      },
      headersDetail: [
          {
            text: 'Tanggal',
            align: 'start',
            value: 'tanggal',
          },
          { text: 'Curah (mm)', value: 'curah' },
        ],
      historicalDetail: [],
      timeDialog: null,
      modal2: false,
      dates:['2022-07-27', '2022-07-29'],
      // loadingData: true,
      tab: null,
      items: [
        'Grafik', 'Tabel',
      ],
      labels:[],
      datasets:[],
      csvTitle:null,
      labelsCSV:{
        tanggal: 'Tanggal',
        curah: 'Curah Hujan (mm)'
      },
      csvTitleRecap:null,
      labelsCSVRecap:{
        lng: 'Longitude',
        lat: 'Latitude',
        station: 'Stasiun'
      },
      dialog4:false,
      modal3:false,
      datesDownload:[(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)],
      recapDetail:[],
      locations: ['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE']
    }),
    async mounted () {
      let loader = this.$loading.show()
      if (localStorage.getItem("role")=='Petugas') {
        let device = localStorage.getItem('device')
        this.$router.push(`/MapPetugas-id=${device}&device=${localStorage.getItem('jenis')}`)
      }
      const date=new Date();
      const today = Date.now()/1000;
      this.dates=[moment.unix(today-604800).utcOffset(this.offset).format("YYYY-MM-DD"),moment.unix(today).utcOffset(this.offset).format("YYYY-MM-DD")],
      this.offset=date.getTimezoneOffset()/(-60)
      
      

      let setByLocation=false
      await db.collection('roleSetting').doc(localStorage.getItem("role")).get().then((doc)=> {
        setByLocation=doc.data().location
      })

      var reportDataRef = db.collection('report')
      if (localStorage.getItem('location')!='MARNOV') {
        reportDataRef = db.collection('report').where('location','in',this.locations)
      }
      
      if (setByLocation) {
        reportDataRef = db.collection('report').where('location','==',localStorage.getItem('location'))
      }

      

      reportDataRef.orderBy("time","desc").onSnapshot((collectionSnapshot) => {
        let i=0
        this.historical=[]
        collectionSnapshot.forEach((doc) => {
          this.historical.push({curah:parseFloat(doc.data().rain).toFixed(2), tenggang:doc.data().expire, quota: doc.data().kuota, timeReport: doc.data().time})
          this.historical[i].id=doc.id
          i++
        });
        db.collection('device').onSnapshot((collectionSnapshot) => {
          i=0
          this.devices=[]
          collectionSnapshot.forEach((doc) => {
            this.devices.push(doc.data())
            this.devices[i].id=doc.id
            i++
          });
          // this.recapDetail=[]
          for (i=0;i<this.historical.length;i++) {
            for (let j=0;j<this.devices.length;j++) {
              if (this.historical[i].id==this.devices[j].id) {
                this.historical[i].location=this.devices[j].location
                this.historical[i].station=this.devices[j].station
                this.historical[i].phoneNumber = this.devices[j].phoneNumber
                this.historical[i].macAddress = this.devices[j].macAddress
                this.historical[i].lat = this.devices[j].latitude
                this.historical[i].lng = this.devices[j].longitude
                this.historical[i].newID = this.devices[j].newID
                this.historical[i].feedingID = this.devices[j].feedingID?this.devices[j].feedingID:this.devices[j].newID
                // this.recapDetail.push({
                //   lat:(this.devices[j].latitude),
                //   lng:(this.devices[j].longitude),
                //   curah: this.historical[i].curah,
                //   station: this.devices[j].station,
                // })
                break;
              }
            }
          }
          this.data=this.historical
          // console.log(this.recapDetail)
          loader.hide()
        })
      })
    },
    computed: {
      dateRangeText () {
        let dateRange=[]
        if (this.dates[0]>this.dates[1]) {
          dateRange[0]=this.dates[1]
          dateRange[1]=this.dates[0]
        } else {
          dateRange[0]=this.dates[0]
          dateRange[1]=this.dates[1]
        }
        return dateRange.join(' ~ ')
      },
      datesDownloadText () {
        let dateRange=[]
        if (this.datesDownload[0]>this.datesDownload[1]) {
          dateRange[0]=this.datesDownload[1]
          dateRange[1]=this.datesDownload[0]
        } else {
          dateRange[0]=this.datesDownload[0]
          dateRange[1]=this.datesDownload[1]
        }
        return dateRange.join(' ~ ')
      },
    },
    methods: {
      updateTime (time) {
        return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
      },
      clicked(item) {
        this.dialog=true
        this.station=item.station
        this.ID=item.id
        this.getData(item.id)
      },
      clickedDownload() {
        this.dialog4=true
        this.getRecap(this.datesDownload)
      },
      async getRecap(time) {
        if (time[0]>time[1]) {
          let temp=this.dates[0]
          time[0]=time[1]
          time[1]=temp
        }
        if (time[1]==undefined) {
          time[1]=time[0]
        }
        let loader=this.$loading.show()
        let setByLocation=false
        let listOfDevice=[]
        await db.collection('roleSetting').doc(localStorage.getItem("role")).get().then((doc)=> {
          setByLocation=doc.data().location
        })

        var reportDataRef = db.collection('report')
        if (localStorage.getItem('location')!='MARNOV') {
          reportDataRef = db.collection('report').where('location','in',this.locations)
        }
        
        if (setByLocation) {
          reportDataRef = db.collection('report').where('location','==',localStorage.getItem('location'))
        }
        console.log(time)
        await reportDataRef.orderBy("time","desc").get().then((docs) => {
          docs.forEach((doc)=> {
            listOfDevice.push(doc.id)
          })
        })

        this.csvTitleRecap = `Rekapitulasi_${time[0]}~${time[1]}.csv`

        let start = (moment(time[0], "YYYY-MM-DD").valueOf()/1000);
        let end = (moment(time[1], "YYYY-MM-DD").valueOf()/1000 +86400);

        let listOfDay=[]
        //Get date list from start to end
        let startDate = moment.unix(start).utcOffset(this.offset) 
        let endDate = moment.unix(end).utcOffset(this.offset)
        while (startDate.isBefore(endDate)) {
          listOfDay.push(startDate.format("DD MMM YYYY"))
          startDate.add(1, 'days')
        }
        console.log(listOfDay)
        for (let i=0; i<listOfDay.length; i++) {
          this.labelsCSVRecap[listOfDay[i]] = listOfDay[i]
        }

        console.log(this.labelsCSVRecap)
        this.recapDetail=[]
        for (let i=0; i<listOfDevice.length; i++) {
          let index = this.devices.findIndex((e)=> e.id==listOfDevice[i])
          let deviceRecap={}
          await db.collection('report').doc(listOfDevice[i]).collection("rain").where("time", ">=", start).where("time", "<=", end).get().then((docs) => {
            docs.forEach((doc)=> {
              deviceRecap[moment.unix(doc.data().time).utcOffset(this.offset).format("DD MMM YYYY")] = parseFloat(doc.data().rain).toFixed(2)
            })
          })
          this.recapDetail.push({
            lat:(this.devices[index].latitude),
            lng:(this.devices[index].longitude),
            station: this.devices[index].station,
            ...deviceRecap
          })
        }
        console.log(this.recapDetail)
        loader.hide()
      },
      getData (id) {
        // this.loadingData= true
        if (this.dates[0]>this.dates[1]) {
          let temp=this.dates[0]
          this.dates[0]=this.dates[1]
          this.dates[1]=temp
        }
        this.csvTitle=`${this.station}-${this.dates[0]}~${this.dates[1]}.csv`
        let start = (moment(this.dates[0], "YYYY-MM-DD").valueOf()/1000);
        let end = (moment(this.dates[1], "YYYY-MM-DD").valueOf()/1000 +86400);
        
        var reportRef = db.collection('report').doc(id).collection('rain')
        reportRef.orderBy("time","desc").where("time", ">=", start).where("time", "<=", end).onSnapshot((collectionSnapshot) => {
          let i=0
          this.historicalDetail=[]
          this.datasets =[]
          this.labels=[]
          collectionSnapshot.forEach((doc) => {
            
            this.historicalDetail.push({tanggal: moment.unix(doc.data().time).utcOffset(this.offset).format("DD MMM YYYY"), curah:doc.data().rain})
            this.labels[i] = moment.unix(doc.data().time).utcOffset(this.offset).format("DD MMM YYYY")
            this.datasets[i] = parseFloat(doc.data().rain).toFixed(2)
            i++
          });
          this.chartData =  {
            labels: this.labels,
            datasets: [ { label: 'Curah',data: this.datasets,backgroundColor: '#3f51b5', } ],
          }
          // this.loadingData=false
        })
      }
    },
  }
</script>
